import { Link, useNavigate, useSearchParams } from "react-router-dom";
import Header from "../../Header/Header";
import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import { privateRequest } from "../../commonApi/CommonApi";
import { Image_URL } from "../../commonApi/CommonApi";
import { Helmet } from "react-helmet";
// const BASE_URL = "http://localhost:5500";
// const BASE_URL = "http://52.87.3.228:5500";

function AllService() {
  const [service, SetService] = useState([]);
  const [DeleteServices, setDeleteServices] = useState([]);
  const [combineData, setCombineData] = useState([]);
  const history = useNavigate();
  const [searchParams] = useSearchParams();
  const searchServiceName = searchParams.get('search');

  const GetService = async () => {
    try {
      const response = await privateRequest.get(`Service/GetServices`);
      SetService(response?.data?.data);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const getAllDocumentData = async () => {
    try {
      const response = await privateRequest.get(`Service/CombineApis`);
      setCombineData(response?.data?.data);
    } catch (error) {
      console.error("Error fetching combine data:", error);
    }
  };

  const getPackagesUsingServiceVariant = async (serviceVariantId) => {
    try {
      const response = await privateRequest.get(`Package/GetPackagesByServiceVariant/${serviceVariantId}`);
      return response?.data?.data || [];
    } catch (error) {
      console.error("Error fetching packages using service variant:", error);
      return [];
    }
  };

  const findPackagesUsingServiceVariant = (serviceVariantId) => {
    if (!combineData?.Package || !serviceVariantId) {
      return [];
    }

    const matchingPackages = combineData.Package.filter(pkg => {
      // Case 1: serviceId array with variant property
      if (pkg.serviceId && Array.isArray(pkg.serviceId)) {
        const hasMatch = pkg.serviceId.some(service => {
          const match = service.variant === serviceVariantId ||
            service.service === serviceVariantId ||
            service._id === serviceVariantId ||
            service.id === serviceVariantId ||
            service.serviceVariant === serviceVariantId ||
            service.variantId === serviceVariantId;
          return match;
        });
        if (hasMatch) {
          return true;
        }
      }

      // Case 2: serviceId array with direct variant IDs
      if (pkg.serviceId && Array.isArray(pkg.serviceId)) {
        const hasMatch = pkg.serviceId.includes(serviceVariantId);
        if (hasMatch) {
          return true;
        }
      }

      // Case 3: Check if package has service variants directly
      if (pkg.ServiceVarients && Array.isArray(pkg.ServiceVarients)) {
        const hasMatch = pkg.ServiceVarients.some(variant => {
          return variant._id === serviceVariantId;
        });
        if (hasMatch) {
          return true;
        }
      }

      // Case 4: Check if package has services array
      if (pkg.services && Array.isArray(pkg.services)) {
        const hasMatch = pkg.services.some(service => {
          return service.variant === serviceVariantId ||
            service.service === serviceVariantId ||
            service._id === serviceVariantId;
        });
        if (hasMatch) {
          return true;
        }
      }

      return false;
    });

    return matchingPackages;
  };

  // Helper function to check if service has any active variant
  const hasAnyActiveVariant = (variants) => {
    return variants?.some(
      (v) =>
        v?.VarientDiscription?.[0]?.ServiceStatus === true ||
        v?.VarientDiscription?.[0]?.ServiceStatus === 1
    );
  };

  // Function to update service status
  const handleServiceStatusChange = async (serviceItem, nextStatus) => {
    const serviceId = serviceItem?._id;
    const currentStatus = hasAnyActiveVariant(serviceItem?.ServiceVarients) ? 1 : 0;

    // If trying to inactivate service, check all active variants
    if (nextStatus === 0 && currentStatus === 1) {
      // Get all active variants
      const activeVariants = serviceItem?.ServiceVarients?.filter(
        (variant) =>
          variant?.VarientDiscription?.[0]?.ServiceStatus === true ||
          variant?.VarientDiscription?.[0]?.ServiceStatus === 1
      ) || [];

      if (activeVariants.length > 0) {
        // Collect packages for all active variants
        let packagesBlocking = [];

        for (const variant of activeVariants) {
          if (!variant._id) continue;
          let packages = [];

          // Try API call first
          try {
            packages = await getPackagesUsingServiceVariant(variant._id);
          } catch (error) {
            console.error("Error fetching packages from API:", error);
            packages = findPackagesUsingServiceVariant(variant._id);
          }

          // If API didn't return results, try local search
          if (packages.length === 0) {
            packages = findPackagesUsingServiceVariant(variant._id);
          }

          if (packages.length > 0) {
            packagesBlocking.push(...packages);
          }
        }

        // Remove duplicate packages
        const uniquePackages = packagesBlocking.filter(
          (pkg, index, self) =>
            index === self.findIndex((p) => p._id === pkg._id)
        );

        // Check if any active packages are using these variants
        const activePackages = uniquePackages.filter(
          (pkg) =>
            pkg.Status === true ||
            pkg.Status === 1 ||
            pkg.status === true ||
            pkg.status === 1
        );

        if (activePackages.length > 0) {
          // Build same table UI as EditService.js
          const packagesTable = uniquePackages
            .map((pkg) => {
              const isActive =
                pkg.Status === true ||
                pkg.Status === 1 ||
                pkg.status === true ||
                pkg.status === 1;

              return `
              <tr>
                <td style="padding:10px 14px; font-size:13px;">
                  ${pkg.packageTitle || pkg.name || pkg._id}
                </td>
                <td style="text-align:center;">
                  <span style="
                    padding:4px 10px;
                    font-size:11px;
                    border-radius:12px;
                    color:#fff;
                    background:${isActive ? "#28a745" : "#6c757d"};
                  ">
                    ${isActive ? "Active" : "Inactive"}
                  </span>
                </td>
                <td style="text-align:center;">
                  <button
                    style="
                      font-size:11px;
                      padding:4px 10px;
                      border-radius:4px;
                      border:none;
                      background:#0d6efd;
                      color:#fff;
                      cursor:pointer;
                    "
                    onclick="editPackage('${pkg._id}')">
                    ✏️ Edit
                  </button>
                </td>
              </tr>
              `;
            })
            .join("");

          // Modal HTML (same style as EditService.js)
          const tableHTML = `
            <div style="text-align:center; margin-bottom:12px;">
              <div style="
                width:72px;
                height:72px;
                border-radius:50%;
                border:4px solid #f0ad4e;
                display:inline-flex;
                align-items:center;
                justify-content:center;
                font-size:34px;
                color:#f0ad4e;
                font-weight:700;
              ">!</div>
            </div>

            <!-- TITLE -->
            <h3 style="text-align:center; font-weight:600; margin-bottom:14px;">
              Service Used in Packages
            </h3>

            <!-- WARNING BAR -->
            <div style="
              background:#fff3cd;
              border:1px solid #ffeeba;
              color:#856404;
              padding:10px 16px;
              font-size:13px;
              border-radius:6px;
              margin-bottom:14px;
              text-align:center;
            ">
              ⚠️ Service is used in active packages.
              You cannot inactivate it.
            </div>

            <!-- TABLE CARD -->
            <div style="
              border:1px solid #dee2e6;
              border-radius:6px;
              overflow:hidden;
              background:#fff;
            ">
              <table style="width:100%; border-collapse:collapse;">
                <thead style="background:#343a40; color:#fff;">
                  <tr style="height:36px; background:#343a40; color:#fff;">
                    <th style="padding:6px 10px; font-size:12px; font-weight:600; text-align:left;">
                      📦 Package Details
                    </th>

                    <th style="padding:6px 10px; font-size:12px; font-weight:600; text-align:center;">
                      ℹ️ Status
                    </th>

                    <th style="padding:6px 10px; font-size:12px; font-weight:600; text-align:center;">
                      ✏️ Action
                    </th>
                  </tr>
                </thead>
                <tbody>
                  ${packagesTable}
                </tbody>
              </table>
            </div>
          `;

          Swal.fire({
            icon: undefined,
            html: tableHTML,
            width: 760,
            confirmButtonText: "OK",
            allowOutsideClick: false,
            customClass: {
              confirmButton: 'swal-btn-sm',
            },
            didOpen: () => {
              window.editPackage = (packageId) => {
                Swal.close();
                window.open(`/package/edit?packageId=${packageId}`, "_blank");
              };
            },
          });

          return; // ⛔ HARD BLOCK — status NOT changed
        }
      }
    }

    // ✅ Safe → update service status
    try {
      const formData = new FormData();
      formData.append("ServiceName", serviceItem?.ServiceName);
      formData.append("PCatId", serviceItem?.PCatId?._id);
      formData.append("ChildCatIDs", serviceItem?.ChildCatIDs?._id);
      formData.append("ServiceStatus", nextStatus === 1 ? true : false);

      // Add all variants with their current data
      serviceItem?.ServiceVarients?.forEach((variant, index) => {
        formData.append(
          `ServiceVarients[${index}][ServiceType]`,
          variant.ServiceType?._id || variant.ServiceType
        );

        const variantDesc = variant.VarientDiscription?.[0] || {};

        // Determine variant status based on service status change
        let variantStatus;

        if (nextStatus === 0) {
          // Service → Inactive → force all variants inactive
          variantStatus = false;
        } else if (nextStatus === 1) {
          // Service → Active → activate FIRST variant automatically if no active variants exist
          if (!hasAnyActiveVariant(serviceItem?.ServiceVarients)) {
            // No active variants, activate the first one (index 0)
            variantStatus = index === 0 ? true : (variantDesc.ServiceStatus || false);
          } else {
            // Already has active variants, keep current status
            variantStatus = variantDesc.ServiceStatus || false;
          }
        } else {
          // Keep current status
          variantStatus = variantDesc.ServiceStatus || false;
        }

        formData.append(
          `ServiceVarients[${index}][VarientDiscription][ServiceStatus]`,
          variantStatus
        );
        formData.append(
          `ServiceVarients[${index}][VarientDiscription][regularPrice]`,
          variantDesc.regularPrice || ""
        );
        formData.append(
          `ServiceVarients[${index}][VarientDiscription][ServiceTime]`,
          variantDesc.ServiceTime || ""
        );
        formData.append(
          `ServiceVarients[${index}][VarientDiscription][salePrice]`,
          variantDesc.salePrice || ""
        );
        formData.append(
          `ServiceVarients[${index}][VarientDiscription][ProductCost]`,
          variantDesc.ProductCost || ""
        );
        formData.append(
          `ServiceVarients[${index}][VarientDiscription][serviceDiscount]`,
          variantDesc.serviceDiscount || ""
        );
        formData.append(
          `ServiceVarients[${index}][VarientDiscription][ShortDiscription]`,
          variantDesc.ShortDiscription || ""
        );
        formData.append(
          `ServiceVarients[${index}][VarientDiscription][ServiceDiscription]`,
          variantDesc.ServiceDiscription || ""
        );
        formData.append(
          `ServiceVarients[${index}][VarientDiscription][IsServiceDiscription]`,
          variantDesc.IsServiceDiscription || false
        );

        // Handle ServiceGroups array
        if (variantDesc.ServiceGroups && Array.isArray(variantDesc.ServiceGroups)) {
          variantDesc.ServiceGroups.forEach((group) => {
            formData.append(
              `ServiceVarients[${index}][VarientDiscription][ServiceGroups]`,
              group._id || group
            );
          });
        }

        // Handle ShowInChildCategory array
        if (variantDesc.ShowInChildCategory && Array.isArray(variantDesc.ShowInChildCategory)) {
          variantDesc.ShowInChildCategory.forEach((category) => {
            formData.append(
              `ServiceVarients[${index}][VarientDiscription][ShowInChildCategory]`,
              category._id || category
            );
          });
        }
      });

      const response = await privateRequest.put(
        `Service/UpdateServices/${serviceId}`,
        formData
      );

      if (response?.data?.success || response?.status === 200) {
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: "Service status updated successfully!",
        });
        GetService(); // Refresh the service list
      } else {
        Swal.fire({
          icon: "error",
          title: "Error!",
          text: response?.data?.message || "Failed to update service status.",
        });
      }
    } catch (error) {
      console.error("Error updating service status:", error);
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: error?.response?.data?.message || "An error occurred while updating the service status.",
      });
    }
  };

  const handleVariantStatusChange = async (serviceId, variantId, currentStatus, nextStatus, serviceItem) => {
    // Only intercept when trying to inactivate
    if (nextStatus === "0" && variantId) {
      let packages = [];

      // Try API call first
      try {
        packages = await getPackagesUsingServiceVariant(variantId);
      } catch (error) {
        console.error("Error fetching packages from API:", error);
        // Fallback to local search
        packages = findPackagesUsingServiceVariant(variantId);
      }

      // If API didn't return results, try local search
      if (packages.length === 0) {
        packages = findPackagesUsingServiceVariant(variantId);
      }

      // Detect active packages
      const activePackages = packages.filter(
        (pkg) =>
          pkg.Status === true ||
          pkg.Status === 1 ||
          pkg.status === true ||
          pkg.status === 1
      );

      if (activePackages.length > 0) {
        // Build same table UI as EditService.js
        const packagesTable = packages
          .map((pkg) => {
            const isActive =
              pkg.Status === true ||
              pkg.Status === 1 ||
              pkg.status === true ||
              pkg.status === 1;

            return `
            <tr style="height: 36px;">
              <td style="padding: 6px 10px;">
                <strong style="font-size: 12px;">
                  ${pkg.packageTitle || pkg.name || pkg._id}
                </strong>
              </td>
              <td style="padding: 6px 10px; text-align:center;">
                <span class="badge ${isActive ? "badge-success" : "badge-secondary"}"
                      style="font-size:10px;">
                  ${isActive ? "Active" : "Inactive"}
                </span>
              </td>
              <td style="padding: 6px 10px;">
                <button
                  class="btn btn-xs btn-primary"
                  style="font-size:10px; padding:2px 6px;"
                  onclick="editPackage('${pkg._id}')">
                  <i class="fas fa-edit"></i> Edit
                </button>
              </td>
            </tr>
            `;
          })
          .join("");

        const tableHTML = `
          <div class="alert alert-warning mb-2"
              style="padding:8px 12px; font-size:12px;">
            <i class="fas fa-exclamation-triangle me-1"></i>
            <strong>This variant is used in active packages.</strong>
            You cannot inactivate it.
          </div>

          <div class="table-responsive"
              style="max-height:160px; overflow-y:auto;
                      border:1px solid #dee2e6; border-radius:4px;">
            <table class="table table-striped mb-0"
                  style="font-size:11px;">
              <thead class="table-dark"
                    style="position:sticky; top:0; z-index:10;">
                <tr>
                  <th style="padding:8px;">
                    <i class="fas fa-box me-1"></i> Package Details
                  </th>
                  <th style="padding:8px; text-align:center;">
                    <i class="fas fa-info-circle me-1"></i> Status
                  </th>
                  <th style="padding:8px;">
                    <i class="fas fa-edit me-1"></i> Action
                  </th>
                </tr>
              </thead>
              <tbody>
                ${packagesTable}
              </tbody>
            </table>
          </div>
        `;

        Swal.fire({
          icon: "warning",
          title: "Variant Used in Packages",
          html: tableHTML,
          width: 700,
          confirmButtonText: "OK",
          allowOutsideClick: false,
          customClass: {
            popup: "swal-compact",
            confirmButton: "btn btn-primary btn-sm",
          },
          didOpen: () => {
            window.editPackage = (packageId) => {
              Swal.close();
              window.open(`/package/edit?packageId=${packageId}`, "_blank");
            };
          },
        });

        return; // ⛔ HARD BLOCK — status NOT changed
      }
    }

    // ✅ Safe → update variant status using UpdateServices API
    try {
      const formData = new FormData();
      formData.append("ServiceName", serviceItem?.ServiceName);
      formData.append("PCatId", serviceItem?.PCatId?._id);
      formData.append("ChildCatIDs", serviceItem?.ChildCatIDs?._id);

      // Calculate service status based on variants
      const updatedVariants = serviceItem?.ServiceVarients?.map(variant => {
        if (variant._id === variantId) {
          return {
            ...variant,
            VarientDiscription: [{
              ...variant.VarientDiscription[0],
              ServiceStatus: nextStatus === "1" ? true : false
            }]
          };
        }
        return variant;
      });

      const newServiceStatus = hasAnyActiveVariant(updatedVariants) ? 1 : 0;
      formData.append("ServiceStatus", newServiceStatus === 1 ? true : false);

      // Add all variants with updated status
      serviceItem?.ServiceVarients?.forEach((variant, index) => {
        formData.append(
          `ServiceVarients[${index}][ServiceType]`,
          variant.ServiceType?._id || variant.ServiceType
        );

        const variantDesc = variant.VarientDiscription?.[0] || {};

        // Update status for the specific variant
        const variantStatus = variant._id === variantId
          ? (nextStatus === "1" ? true : false)
          : (variantDesc.ServiceStatus || false);

        formData.append(
          `ServiceVarients[${index}][VarientDiscription][ServiceStatus]`,
          variantStatus
        );
        formData.append(
          `ServiceVarients[${index}][VarientDiscription][regularPrice]`,
          variantDesc.regularPrice || ""
        );
        formData.append(
          `ServiceVarients[${index}][VarientDiscription][ServiceTime]`,
          variantDesc.ServiceTime || ""
        );
        formData.append(
          `ServiceVarients[${index}][VarientDiscription][salePrice]`,
          variantDesc.salePrice || ""
        );
        formData.append(
          `ServiceVarients[${index}][VarientDiscription][ProductCost]`,
          variantDesc.ProductCost || ""
        );
        formData.append(
          `ServiceVarients[${index}][VarientDiscription][serviceDiscount]`,
          variantDesc.serviceDiscount || ""
        );
        formData.append(
          `ServiceVarients[${index}][VarientDiscription][ShortDiscription]`,
          variantDesc.ShortDiscription || ""
        );
        formData.append(
          `ServiceVarients[${index}][VarientDiscription][ServiceDiscription]`,
          variantDesc.ServiceDiscription || ""
        );
        formData.append(
          `ServiceVarients[${index}][VarientDiscription][IsServiceDiscription]`,
          variantDesc.IsServiceDiscription || false
        );

        // Handle ServiceGroups array
        if (variantDesc.ServiceGroups && Array.isArray(variantDesc.ServiceGroups)) {
          variantDesc.ServiceGroups.forEach((group) => {
            formData.append(
              `ServiceVarients[${index}][VarientDiscription][ServiceGroups]`,
              group._id || group
            );
          });
        }

        // Handle ShowInChildCategory array
        if (variantDesc.ShowInChildCategory && Array.isArray(variantDesc.ShowInChildCategory)) {
          variantDesc.ShowInChildCategory.forEach((category) => {
            formData.append(
              `ServiceVarients[${index}][VarientDiscription][ShowInChildCategory]`,
              category._id || category
            );
          });
        }
      });

      const response = await privateRequest.put(
        `Service/UpdateServices/${serviceId}`,
        formData
      );

      if (response?.data?.success || response?.status === 200) {
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: "Variant status updated successfully!",
        });
        GetService(); // Refresh the service list
      } else {
        Swal.fire({
          icon: "error",
          title: "Error!",
          text: response?.data?.message || "Failed to update variant status.",
        });
      }
    } catch (error) {
      console.error("Error updating variant status:", error);
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: error?.response?.data?.message || "An error occurred while updating the variant status.",
      });
    }
  };

  const deleteChild = async (_id) => {
    try {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "You will not be able to recover this item!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, cancel",
        closeOnConfirm: false,
        closeOnCancel: true,
      });

      if (result.isConfirmed) {
        const response = await privateRequest.delete(
          `Service/DeleteServices/${_id}`
        );

        setDeleteServices(DeleteServices.filter((item) => item._id !== _id));
        GetService();
        Swal.fire("Deleted!", "Your item has been deleted.", "success");
      } else {
        Swal.fire(
          "Cancelled",
          "Your item deletion has been cancelled.",
          "info"
        );
      }
    } catch (error) {
      console.error("DELETE Error:", error);
      Swal.fire("Error!", "Failed to delete item.", "error");
    }
  };

  const deleteVariantChild = async (_id, variantId) => {
    try {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "You will not be able to recover this item!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, cancel",
        closeOnConfirm: false,
        closeOnCancel: true,
      });

      if (result.isConfirmed) {
        const response = await privateRequest.delete(
          `Service/DeleteServicevarient`,
          {
            data: { serviceId: _id, varientId: variantId }, // Pass data object for request body
          }
        );

        setDeleteServices(DeleteServices.filter((item) => item._id !== _id));
        GetService();
        Swal.fire("Deleted!", "Your item has been deleted.", "success");
      } else {
        Swal.fire(
          "Cancelled",
          "Your item deletion has been cancelled.",
          "info"
        );
      }
    } catch (error) {
      console.error("DELETE Error:", error);
      Swal.fire("Error!", "Failed to delete item.", "error");
    }
  };

  useEffect(() => {
    GetService();
    getAllDocumentData();
  }, []);

  // Refresh data when window regains focus (user comes back to this tab)
  useEffect(() => {
    const handleFocus = () => {
      console.log('Window focused - refreshing service data...');
      GetService();
      getAllDocumentData();
    };

    window.addEventListener('focus', handleFocus);

    return () => {
      window.removeEventListener('focus', handleFocus);
    };
  }, []);

  // Handle search when page is opened with search parameter from packages page
  useEffect(() => {
    if (searchServiceName && service.length > 0) {
      // Wait for DataTable to initialize
      const timer = setTimeout(() => {
        try {
          // Get DataTable instance
          const table = window.jQuery && window.jQuery('#my_table').DataTable();

          if (table && searchServiceName) {
            // Use DataTable search to filter
            table.search(searchServiceName).draw();
          }
        } catch (error) {
          console.error('Error handling search:', error);
        }
      }, 1000); // Wait 1 second for DataTable to initialize

      return () => clearTimeout(timer);
    }
  }, [searchServiceName, service]);

  return (
    <>
      {service.length > 0 && (
        <Helmet>
          <script>new DataTable("#my_table");</script>
        </Helmet>
      )}
      <div className="app-main">
        <div className="wrapper">
          <div className="page">
            <div className="page-inner px-0">
              <div className="container-fluid">
                <header className="page-title-bar">
                  <div className="d-flex flex-column flex-md-row">
                    <p className="lead mb-0">
                      <span className="font-weight-bold">Services</span>
                    </p>
                    <Link
                      to="/service/new"
                      className="btn btn-primary btn-sm ml-auto"
                      data-toggle="modal"
                      data-target="#childModal"
                    >
                      <i className="fa fa-plus mr-2"></i>Add New
                    </Link>
                  </div>
                </header>
                <div className="page-section">
                  <div className="card" style={{ borderRadius: "15px" }}>
                    <div className="card-body table-responsive">
                      <table
                        id="my_table"
                        className="table table-striped text-nowrap table-sm dataTable no-footer table-bordered"
                      >
                        <thead className="bg-primary text-white">
                          <tr>
                            <th scope="col">Sr No</th>

                            <th scope="col">Service</th>
                            <th scope="col">Parent Cat.</th>
                            <th scope="col" style={{ width: "200px" }}>
                              Child Cat.
                            </th>
                            <th scope="col">Service Variants</th>

                            <th scope="col">Created</th>
                            <th scope="col">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {service?.map((item, index) => {
                            let SeviceID = item?._id;
                            let PCatName = item?.PCatId?.PCName;
                            const serviceStatus = hasAnyActiveVariant(item?.ServiceVarients) ? 1 : 0;

                            return (
                              <tr key={index} data-service-id={item?._id}>
                                <td className="align-center">{index + 1}</td>

                                <td className="align-center">
                                  {item?.ServiceName}
                                </td>
                                <td className="align-center">
                                  {item?.PCatId?.PCName}
                                </td>
                                <td className="align-center">
                                  <span
                                    key={item?.ChildCatIDs?._id}
                                    className="badge badge-primary mr-1"
                                  >
                                    {item?.ChildCatIDs?.CCName}
                                  </span>
                                </td>

                                <td className="align-center">
                                  <table className="table table-sm text-nowrap table-bordered">
                                    <thead className="bg-primary text-white">
                                      <tr>
                                        <th>
                                          <i className="fa fa-image"></i>
                                        </th>
                                        <th>Type</th>
                                        <th>Price</th>
                                        <th>Dis</th>
                                        <th>Timing</th>
                                        <th>Group</th>
                                        <th>Status</th>
                                        <th>Change Status</th>
                                        <th>#</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {item?.ServiceVarients.map(
                                        (variantItem, variantIndex) => {
                                          const currentStatus = variantItem?.VarientDiscription[0]?.ServiceStatus == true ? "1" : "0";

                                          return (
                                            <tr key={variantIndex}>
                                              <td>
                                                <img
                                                  style={{
                                                    width: "50px",
                                                    height: "50px",
                                                    borderRadius: "7px",
                                                  }}
                                                  src={
                                                    Image_URL +
                                                    variantItem?.VarientDiscription[0]
                                                      ?.ServiceImage
                                                  }
                                                />
                                              </td>
                                              <td>
                                                <p>
                                                  {variantItem?.ServiceType?.Name}
                                                </p>
                                              </td>
                                              <td>
                                                <del className="mr-2">
                                                  ₹{" "}
                                                  {
                                                    variantItem?.VarientDiscription[0]
                                                      ?.regularPrice
                                                  }
                                                </del>
                                                ₹{" "}
                                                {
                                                  variantItem?.VarientDiscription[0]
                                                    ?.salePrice
                                                }
                                              </td>
                                              <td>
                                                {
                                                  variantItem?.VarientDiscription[0]
                                                    ?.serviceDiscount
                                                }
                                                %
                                              </td>
                                              <td>
                                                {
                                                  variantItem?.VarientDiscription[0]
                                                    ?.ServiceTime
                                                }{" "}
                                                mins
                                              </td>
                                              <td>
                                                {variantItem?.VarientDiscription[0]?.ServiceGroups.map(
                                                  (groupItem, groupIndex) => {
                                                    return (
                                                      <span key={groupIndex} className="badge badge-primary mr-1">
                                                        {groupItem?.GroupName}
                                                      </span>
                                                    );
                                                  }
                                                )}
                                              </td>

                                              <td className="text-center">
                                                <label className="switch">
                                                  <input
                                                    type="checkbox"
                                                    checked={currentStatus === "1"}
                                                    onChange={(e) => {
                                                      const nextStatus = e.target.checked ? "1" : "0";

                                                      handleVariantStatusChange(
                                                        SeviceID,
                                                        variantItem?._id,
                                                        currentStatus,
                                                        nextStatus,
                                                        item
                                                      );
                                                    }}
                                                  />
                                                  <span className="slider round"></span>
                                                </label>
                                              </td>


                                              <td>
                                                <button
                                                  onClick={() => {
                                                    deleteVariantChild(
                                                      SeviceID,
                                                      variantItem?._id
                                                    );
                                                  }}
                                                  className="btn btn-danger btn-sm btn-icon"
                                                >
                                                  <i className="fa fa-trash"></i>
                                                </button>

                                                {/* copy icon */}
                                                <button
                                                  className="btn btn-secondary btn-sm"
                                                  onClick={() => {
                                                    const deeplink = `https://www.experts4u.in/service-detail/${variantItem?.VarientDiscription[0]?.ShowInChildCategory?.[0]?._id}/${variantItem?.VarientDiscription[0]?.ShowInChildCategory?.[0]?.PCName?.[0]}/${variantItem?.VarientDiscription[0]?.ShowInChildCategory?.[0]?.PCName?.[0]}/${PCatName}/${SeviceID}/${variantItem?._id}/${variantItem?.VarientDiscription[0]?.ServiceGroups?.[0]?._id}/${variantItem?.VarientDiscription[0]?.ServiceGroups?.[0]?._id}`.replace(/ /g, '%20');
                                                    navigator.clipboard.writeText(deeplink).then(() => {
                                                      Swal.fire("Copied!", "Deeplink has been copied to clipboard.", "success");
                                                    }).catch((error) => {
                                                      Swal.fire("Error!", "Failed to copy deeplink.", "error");
                                                    });
                                                  }}
                                                >
                                                  <i className="fa fa-copy"></i>
                                                </button>
                                              </td>
                                            </tr>
                                          );
                                        }
                                      )}
                                    </tbody>
                                  </table>
                                </td>

                                <td className="align-center">
                                  <p className="mb-0">
                                    {item.ServiceCreatedBy?.name}
                                  </p>
                                  <p className="mb-0">
                                    {new Date(
                                      item.createdAt
                                    ).toLocaleDateString("en-US", {
                                      day: "numeric",
                                      month: "long",
                                      year: "numeric",
                                    })}
                                  </p>
                                </td>
                                <td className="align-center">
                                  <div className="btn-group-vertical">
                                    <div className="btn-group">
                                      <button
                                        onClick={() => {
                                          history("/service/edit", {
                                            state: item,
                                          });
                                        }}
                                        className="btn btn-primary btn-sm"
                                      >
                                        <i className="fa fa-edit"></i>
                                      </button>

                                      <button
                                        className="btn btn-danger btn-sm"
                                        onClick={() => deleteChild(item._id)}
                                      >
                                        <i className="fa fa-trash"></i>
                                      </button>
                                    </div>

                                    {/* Service Status Toggle */}
                                    <div className="mt-2">
                                      <label className="switch" style={{ display: "block", textAlign: "center" }}>
                                        <input
                                          type="checkbox"
                                          checked={serviceStatus === 1}
                                          onChange={(e) => {
                                            handleServiceStatusChange(
                                              item,
                                              e.target.checked ? 1 : 0
                                            );
                                          }}
                                        />
                                        <span className="slider round"></span>
                                      </label>

                                    </div>
                                  </div>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Add CSS for toggle switch */}
      <style>{`
        .switch {
          position: relative;
          display: inline-block;
          width: 34px;
          height: 18px;
        }

        .switch input {
          opacity: 0;
        }

        .slider {
          position: absolute;
          inset: 0;
          background-color: #ccc;
          border-radius: 20px;
          transition: 0.3s;
        }

        .slider:before {
          content: "";
          position: absolute;
          height: 14px;
          width: 14px;
          left: 2px;
          bottom: 2px;
          background-color: white;
          border-radius: 50%;
          transition: 0.3s;
        }

        input:checked + .slider {
          background-color: #28a745;
        }

        input:checked + .slider:before {
          transform: translateX(16px);
        }
      `}</style>
    </>
  );
}

export default AllService;
